// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════
   DMSDashboard.css — Premium Power BI-style Migration Dashboard
   Glassmorphism · Frosted transparency · Cloud migration aesthetic
   Full light/dark theming via CSS variables
   ════════════════════════════════════════════════════════════════ */

/* ── Design Tokens ─────────────────────────────────────────────── */
.dboard {
    --d-text-primary: var(--text-main, #f1f5f9);
    --d-text-secondary: var(--text-secondary, #94a3b8);
    --d-text-muted: var(--text-muted, #64748b);
    --d-card-bg: var(--card-bg, rgba(15, 23, 42, 0.6));
    --d-card-border: var(--card-border, rgba(255, 255, 255, 0.07));
    --d-input-bg: rgba(255, 255, 255, 0.04);
    --d-input-border: rgba(255, 255, 255, 0.08);
    --d-hover-bg: rgba(255, 255, 255, 0.03);
    --d-success-glow: rgba(16, 185, 129, 0.15);
    --d-running-glow: rgba(59, 130, 246, 0.15);
    --d-failed-glow: rgba(239, 68, 68, 0.15);

    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif;
    color: var(--d-text-primary);
    padding-bottom: 2rem;
}

/* ── Dashboard Header ──────────────────────────────────────────── */
/* Dashboard Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */
.dboard-header-right {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    flex-wrap: wrap;
}

/* ── Header Buttons & Controls ─────────────────────────────────── */
.d-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    background: var(--d-input-bg);
    border: 1px solid var(--d-input-border);
    border-radius: 8px;
    color: var(--d-text-secondary);
    font-family: inherit;
    font-size: 0.76rem;
    font-weight: 600;
    padding: 0.45rem 0.85rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    white-space: nowrap;
}

.d-btn:hover {
    background: rgba(129, 140, 248, 0.1);
    border-color: rgba(129, 140, 248, 0.4);
    color: var(--d-text-primary);
    transform: translateY(-1px);
}

.d-btn.active {
    background: rgba(129, 140, 248, 0.15);
    border-color: rgba(129, 140, 248, 0.5);
    color: #818cf8;
    box-shadow: 0 4px 12px rgba(129, 140, 248, 0.15);
}

.d-btn-icon {
    padding: 0.45rem 0.65rem;
}

.d-filter-dot {
    position: absolute;
    top: 4px;
    right: 5px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #818cf8;
    box-shadow: 0 0 6px #818cf8;
}

/* Auto-refresh toggle */
.d-toggle-wrap {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.d-toggle-label {
    font-size: 0.74rem;
    font-weight: 700;
    color: var(--d-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.toggle-sw {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
}

.toggle-sw input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-knob {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    cursor: pointer;
    transition: background 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.toggle-knob::before {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    left: 3px;
    bottom: 3px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.toggle-sw input:checked+.toggle-knob {
    background: #818cf8;
}

.toggle-sw input:checked+.toggle-knob::before {
    transform: translateX(16px);
}

/* ── Filters Panel ─────────────────────────────────────────────── */
.d-filters-panel {
    background: var(--d-card-bg);
    border: 1px solid var(--d-card-border);
    border-radius: 12px;
    padding: 0.5rem 1rem 0.8rem;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    margin-bottom: 0.6rem;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);
    position: relative;
    z-index: 50;
}

.d-filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    align-items: flex-end;
}

.d-filter-item {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 140px;
    flex: 1 1;
}

.d-filter-item label {
    font-size: 0.65rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-muted);
}

.d-filter-item select,
.d-filter-search-wrap input {
    background: var(--d-input-bg);
    border: 1px solid var(--d-input-border);
    border-radius: 8px;
    color: var(--d-text-primary);
    font-family: inherit;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 0.4rem 0.75rem;
    height: 36px;
    cursor: pointer;
    outline: none;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.d-filter-item select:hover,
.d-filter-search-wrap input:hover {
    border-color: rgba(129, 140, 248, 0.3);
    background: rgba(255, 255, 255, 0.06);
}

.d-filter-item select:focus,
.d-filter-search-wrap input:focus {
    border-color: rgba(129, 140, 248, 0.6);
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.15);
}

.d-filter-search-wrap {
    position: relative;
    display: flex;
    align-items: flex-end;
    min-width: 200px;
    flex: 1.5 1;
}

.d-search-icon {
    position: absolute;
    left: 10px;
    bottom: 10px;
    color: var(--d-text-muted);
    pointer-events: none;
}

.d-filter-search-wrap input {
    padding-left: 30px;
    width: 100%;
}

.d-reset-btn {
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.28);
    border-radius: 8px;
    color: #f87171;
    font-family: inherit;
    font-size: 0.74rem;
    font-weight: 700;
    padding: 0.35rem 0.95rem;
    cursor: pointer;
    align-self: flex-end;
    height: 36px;
    transition: all 0.2s;
}

.d-reset-btn:hover {
    background: rgba(239, 68, 68, 0.18);
    border-color: rgba(239, 68, 68, 0.45);
    transform: translateY(-1px);
}

/* ── KPI Grid ──────────────────────────────────────────────────── */
.kpi-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.8rem;
}

@media (max-width: 1350px) {
    .kpi-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 920px) {
    .kpi-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 520px) {
    .kpi-grid {
        grid-template-columns: 1fr;
    }
}

.kpi-card {
    background: var(--d-card-bg);
    border: 1px solid var(--d-card-border);
    border-radius: 14px;
    padding: 1rem 1.1rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

/* Top accent bar */
.kpi-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--kpi-accent, #818cf8);
    opacity: 0.65;
    border-radius: 14px 14px 0 0;
    transition: opacity 0.2s;
}

/* Soft glow bottom-right blob */
.kpi-card::after {
    content: '';
    position: absolute;
    bottom: -22px;
    right: -22px;
    width: 65px;
    height: 65px;
    border-radius: 50%;
    background: var(--kpi-accent, #818cf8);
    opacity: 0.03;
    pointer-events: none;
    transition: opacity 0.25s;
}

.kpi-card:hover {
    transform: translateY(-3px);
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
}

.kpi-card:hover::after {
    opacity: 0.08;
}

.kpi-card.kpi-active {
    border-color: color-mix(in srgb, var(--kpi-accent, #818cf8) 60%, transparent);
    box-shadow: 0 0 0 1px color-mix(in srgb, var(--kpi-accent, #818cf8) 25%, transparent),
        0 8px 24px rgba(0, 0, 0, 0.18);
    background: color-mix(in srgb, var(--kpi-accent, #818cf8) 6%, var(--d-card-bg));
}

.kpi-card.kpi-active::before {
    opacity: 1;
}

.kpi-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.kpi-label {
    font-size: 0.65rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-secondary);
}

.kpi-icon {
    color: var(--kpi-accent, #818cf8);
    opacity: 0.65;
    display: flex;
    align-items: center;
}

.kpi-bottom-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.35rem;
}

.kpi-value {
    font-size: 1.7rem;
    font-weight: 900;
    letter-spacing: -0.03em;
    line-height: 1;
    color: var(--d-text-primary);
}

/* KPI hint */
.kpi-hint-bar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.72rem;
    color: var(--d-text-muted);
    margin-top: -0.35rem;
}

.kpi-clear-btn {
    background: rgba(129, 140, 248, 0.1);
    border: 1px solid rgba(129, 140, 248, 0.28);
    border-radius: 6px;
    color: #818cf8;
    font-family: inherit;
    font-size: 0.65rem;
    font-weight: 800;
    padding: 0.15rem 0.5rem;
    cursor: pointer;
    margin-left: 4px;
    transition: all 0.15s;
}

.kpi-clear-btn:hover {
    background: rgba(129, 140, 248, 0.22);
    color: #a5b4fc;
}

/* ── Card Layout ───────────────────────────────────────────────── */
.d-row {
    display: grid;
    gap: 0.85rem;
}

.d-row-2col {
    grid-template-columns: 1fr 1fr;
}

.d-row-full {
    grid-template-columns: 1fr;
}

@media (max-width: 920px) {
    .d-row-2col {
        grid-template-columns: 1fr;
    }
}

.d-card {
    background: var(--d-card-bg);
    border: 1px solid var(--d-card-border);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
}

.d-card:hover {
    border-color: rgba(255, 255, 255, 0.11);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
}

.d-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1.1rem 0.65rem;
    border-bottom: 1px solid var(--d-card-border);
    flex-wrap: wrap;
}

.d-card-title-group {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    flex: 1 1;
    min-width: 150px;
}

.d-card-title {
    margin: 0;
    font-size: 0.76rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-secondary);
}

.d-card-sub {
    font-size: 0.78rem;
    font-weight: 500;
    color: var(--d-text-secondary);
    margin-top: 0.25rem;
    line-height: 1.4;
}

.d-card-body {
    padding: 0.85rem 1.1rem;
    flex: 1 1;
    min-height: 80px;
    overflow-x: auto;
}

/* Card Header Toggles (Power BI style) */
.d-card-tabs {
    display: inline-flex;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid var(--d-input-border);
    border-radius: 8px;
    padding: 2px;
    gap: 2px;
}

.d-card-tab {
    background: transparent;
    border: none;
    border-radius: 6px;
    color: var(--d-text-secondary);
    font-family: inherit;
    font-size: 0.65rem;
    font-weight: 700;
    padding: 0.3rem 0.65rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.d-card-tab:hover {
    color: var(--d-text-primary);
}

.d-card-tab.active {
    background: #818cf8;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(129, 140, 248, 0.4);
}

/* Live pill */
.d-live-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 0.64rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #10b981;
    background: rgba(16, 185, 129, 0.1);
    border: 1px solid rgba(16, 185, 129, 0.25);
    border-radius: 20px;
    padding: 0.16rem 0.6rem;
}

.d-view-all {
    font-size: 0.72rem;
    font-weight: 700;
    color: #818cf8;
    text-decoration: none;
    transition: color 0.15s;
    flex-shrink: 0;
}

.d-view-all:hover {
    color: #a5b4fc;
}

/* ── Empty State ───────────────────────────────────────────────── */
.d-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    min-height: 140px;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--d-text-muted);
    text-align: center;
    padding: 2.5rem 1.5rem;
}

/* ── Section 1: Donut Chart ────────────────────────────────────── */
.donut-wrap {
    display: flex;
    align-items: center;
    gap: 2.5rem;
    padding: 0.4rem 0;
}

.donut-svg-box {
    width: 170px;
    height: 170px;
    flex-shrink: 0;
    position: relative;
}

.donut-seg {
    transition: stroke-width 0.25s, filter 0.25s;
}

.donut-seg:hover {
    stroke-width: 19;
}

.donut-legend {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.donut-legend-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.35rem 0.55rem;
    border-radius: 8px;
    transition: background 0.18s;
}

.donut-legend-row:hover,
.donut-legend-row.active {
    background: rgba(255, 255, 255, 0.04);
}

.legend-dot {
    width: 9px;
    height: 9px;
    border-radius: 3px;
    flex-shrink: 0;
}

.legend-name {
    font-size: 0.74rem;
    font-weight: 700;
    color: var(--d-text-secondary);
    flex: 1 1;
}

.legend-count {
    font-size: 0.82rem;
    font-weight: 900;
    color: var(--d-text-primary);
}

.legend-pct {
    font-size: 0.68rem;
    font-weight: 600;
    color: var(--d-text-muted);
    min-width: 42px;
    text-align: right;
}

@media (max-width: 480px) {
    .donut-wrap {
        flex-direction: column;
        gap: 1.5rem;
    }

    .donut-svg-box {
        width: 140px;
        height: 140px;
    }
}

/* ── Section 2: Total Data Migrated (Horizontal bars) ─────────── */
.hbar-list {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
}

.hbar-row {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.hbar-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.6rem;
}

.hbar-label-left {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    flex: 1 1;
    overflow: hidden;
    min-width: 0;
}

.hbar-path-name {
    font-size: 0.74rem;
    font-weight: 700;
    color: var(--d-text-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.hbar-val {
    font-size: 0.78rem;
    font-weight: 800;
    flex-shrink: 0;
}

.hbar-track {
    height: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 5px;
    overflow: hidden;
}

.hbar-fill {
    height: 100%;
    border-radius: 5px;
    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.hbar-sub {
    font-size: 0.62rem;
    color: var(--d-text-muted);
    font-weight: 500;
}

/* ── Section 3: Source→Target Relationship ─────────────────────── */
.rel-list {
    display: flex;
    flex-direction: column;
    padding: 0.1rem 0;
}

.rel-row {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    position: relative;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    border: 1px solid transparent;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    animation: slideInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.rel-row:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.07);
    transform: translateX(6px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

html[data-theme="light"] .rel-row:hover {
    background: rgba(0, 0, 0, 0.02);
    border-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.rel-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.rel-path {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    flex: 1 1;
    overflow: hidden;
    min-width: 0;
}

.rel-src,
.rel-tgt {
    font-size: 0.74rem;
    font-weight: 700;
    color: var(--d-text-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
}

.rel-arrow {
    font-size: 0.68rem;
    color: var(--d-text-muted);
    flex-shrink: 0;
}

.rel-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
}

.rel-sr {
    font-size: 0.65rem;
    font-weight: 800;
}

.rel-bar-container {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    width: 100%;
}

.rel-track {
    height: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
    overflow: hidden;
    flex: 1 1;
}

html[data-theme="light"] .rel-track {
    background: rgba(0, 0, 0, 0.04);
}

.rel-fill {
    height: 100%;
    border-radius: 4px;
    animation: growBar 1.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.rel-count-end {
    font-size: 0.72rem;
    font-weight: 800;
    color: var(--d-text-secondary);
    min-width: 22px;
    text-align: right;
    flex-shrink: 0;
}

/* Relationship Tooltip (glassmorphism) */
.rel-tooltip {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    background: rgba(15, 23, 42, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 8px 12px;
    color: #f8fafc;
    font-size: 0.68rem;
    z-index: 100;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.rel-row:hover .rel-tooltip {
    visibility: visible;
    opacity: 1;
}

/* ── Section 4: Radial Gauge ────────────────────────────────────── */
.gauge-container-rel {
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 1.25rem;
    align-items: center;
    width: 100%;
    height: 100%;
}

.gauge-left {
    flex: 1 1 45%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 150px;
}

.gauge-right {
    flex: 1 1 55%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.8rem;
    width: 100%;
}

.gauge-center {
    position: absolute;
    top: 72%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.gauge-ring-svg {
    height: 150px;
    width: auto;
    display: block;
}

.gauge-mini-chip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid var(--d-card-border);
    border-radius: 8px;
    padding: 0.5rem 0.8rem;
    width: 100%;
    box-sizing: border-box;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    animation: slideInRight 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.gauge-mini-chip:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.12);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

html[data-theme="light"] .gauge-mini-chip {
    background: rgba(0, 0, 0, 0.015);
}

html[data-theme="light"] .gauge-mini-chip:hover {
    background: rgba(0, 0, 0, 0.035);
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.g-chip-label {
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    color: var(--d-text-muted);
    letter-spacing: 0.05em;
}

.g-chip-value {
    font-size: 1.15rem;
    font-weight: 900;
}

.color-green {
    color: #10b981 !important;
}

.color-red {
    color: #f87171 !important;
}

/* Gauge Tooltip */
.gauge-tooltip {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    background: rgba(15, 23, 42, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 8px 12px;
    color: #f8fafc;
    font-size: 0.68rem;
    z-index: 100;
    bottom: 80%;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.gauge-container-rel:hover .gauge-tooltip {
    visibility: visible;
    opacity: 1;
}

/* Compact layout overrides for cards */
.d-card-compact .d-card-header {
    padding: 0.65rem 1rem 0.45rem;
}

.d-card-compact .d-card-body {
    padding: 0.65rem 1rem;
}

/* Animations */
@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(12px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(15px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes growBar {
    from {
        width: 0%;
    }
}

/* ── Section 5 / 6: Data Tables ────────────────────────────────── */
.d-table-scroll {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 320px;
}

.d-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.74rem;
}

.d-table th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--d-card-bg);
    text-align: left;
    font-size: 0.62rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-primary);
    padding: 0.65rem 0.95rem;
    border-bottom: 1px solid var(--d-card-border);
    white-space: nowrap;
}

.d-table td {
    padding: 0.65rem 0.95rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    color: var(--d-text-secondary);
    font-weight: 500;
    vertical-align: middle;
}

.d-table-row {
    cursor: pointer;
}

.d-table-row:hover td {
    background: var(--d-hover-bg);
}

.d-table-row:last-child td {
    border-bottom: none;
}

.d-name-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    max-width: 240px;
    overflow: hidden;
}

.d-job-name {
    color: var(--d-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 180px;
}

.d-live-badge {
    font-size: 0.54rem;
    font-weight: 900;
    color: #10b981;
    background: rgba(16, 185, 129, 0.1);
    border: 1px solid rgba(16, 185, 129, 0.28);
    border-radius: 4px;
    padding: 0.1rem 0.32rem;
    letter-spacing: 0.05em;
    flex-shrink: 0;
}

.d-path-cell {
    font-size: 0.68rem;
    color: var(--d-text-muted) !important;
    white-space: nowrap;
}

.d-engine-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
}

.d-bytes-cell {
    color: #38bdf8 !important;
}

.d-small {
    font-size: 0.66rem !important;
    white-space: nowrap;
}

.d-muted {
    color: var(--d-text-muted) !important;
}

/* Progress bar */
.d-prog-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 100px;
}

.d-prog-track {
    flex: 1 1;
    height: 6px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 4px;
    overflow: hidden;
}

.d-prog-fill {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
    border-radius: 4px;
    transition: width 0.5s ease;
}

.d-prog-num {
    font-size: 0.66rem;
    font-weight: 800;
    color: #60a5fa;
    white-space: nowrap;
}

/* Status Badges */
.d-badge {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 20px;
    font-size: 0.64rem;
    font-weight: 800;
    letter-spacing: 0.03em;
    white-space: nowrap;
}

.d-badge-running {
    background: rgba(59, 130, 246, 0.12);
    color: #60a5fa;
    border: 1px solid rgba(59, 130, 246, 0.28);
}

.d-badge-completed {
    background: rgba(16, 185, 129, 0.12);
    color: #34d399;
    border: 1px solid rgba(16, 185, 129, 0.28);
}

.d-badge-failed {
    background: rgba(239, 68, 68, 0.12);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.28);
}

.d-badge-cancelled {
    background: rgba(245, 158, 11, 0.1);
    color: #fbbf24;
    border: 1px solid rgba(245, 158, 11, 0.28);
}

.d-badge-pending {
    background: rgba(148, 163, 184, 0.1);
    color: #94a3b8;
    border: 1px solid rgba(148, 163, 184, 0.28);
}

/* ── Drilldown Panel ────────────────────────────────────────────── */
.drilldown-card {
    background: var(--d-card-bg);
    border: 1px solid rgba(129, 140, 248, 0.35);
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.1), 0 12px 42px rgba(0, 0, 0, 0.26);
    animation: slideDown 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
}

.drilldown-hdr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.9rem 1.25rem;
    border-bottom: 1px solid var(--d-card-border);
    background: rgba(129, 140, 248, 0.04);
}

.drilldown-title {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--d-text-primary);
    flex: 1 1;
    flex-wrap: wrap;
}

.drilldown-close {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--d-card-border);
    border-radius: 8px;
    color: var(--d-text-muted);
    font-size: 1.2rem;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.18s;
    flex-shrink: 0;
    line-height: 1;
}

.drilldown-close:hover {
    background: rgba(239, 68, 68, 0.15);
    border-color: rgba(239, 68, 68, 0.3);
    color: #f87171;
}

.drilldown-meta-strip {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-bottom: 1px solid var(--d-card-border);
}

@media (max-width: 700px) {
    .drilldown-meta-strip {
        grid-template-columns: 1fr 1fr;
    }
}

.drilldown-meta-card {
    padding: 0.85rem 1.25rem;
    border-right: 1px solid var(--d-card-border);
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.drilldown-meta-card:last-child {
    border-right: none;
}

.dm-label {
    font-size: 0.62rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-muted);
}

.dm-val {
    font-size: 1.15rem;
    font-weight: 900;
    letter-spacing: -0.02em;
}

.dm-cyan {
    color: #38bdf8;
}

.dm-red {
    color: #f87171;
}

.dm-green {
    color: #34d399;
}

.drilldown-detail-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-bottom: 1px solid var(--d-card-border);
}

@media (max-width: 700px) {
    .drilldown-detail-grid {
        grid-template-columns: 1fr 1fr;
    }
}

.drilldown-detail-item {
    padding: 0.75rem 1.25rem;
    border-right: 1px solid var(--d-card-border);
    border-bottom: 1px solid var(--d-card-border);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.drilldown-detail-item:nth-child(3n) {
    border-right: none;
}

.dd-label {
    font-size: 0.6rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-muted);
}

.dd-val {
    font-size: 0.78rem;
    font-weight: 700;
    color: var(--d-text-primary);
}

/* Synced tables */
.synced-section {
    padding: 0.95rem 1.25rem;
    border-bottom: 1px solid var(--d-card-border);
}

.synced-hdr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.6rem;
    margin-bottom: 0.8rem;
    flex-wrap: wrap;
}

.synced-hdr>span {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.68rem;
    font-weight: 800;
    color: var(--d-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.synced-search-wrap {
    position: relative;
}

.synced-search-icon {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--d-text-muted);
    pointer-events: none;
}

.synced-search-input {
    padding-left: 26px;
    font-size: 0.7rem;
    height: 28px;
    border-radius: 6px;
    background: var(--d-input-bg);
    border: 1px solid var(--d-input-border);
    color: var(--d-text-primary);
    font-family: inherit;
    outline: none;
    min-width: 160px;
}

.synced-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.synced-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid var(--d-card-border);
    border-radius: 6px;
    padding: 0.3rem 0.6rem;
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--d-text-secondary);
    transition: background 0.15s;
}

.synced-chip:hover {
    background: rgba(255, 255, 255, 0.06);
}

.chip-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

.synced-chip-completed .chip-dot {
    background: #10b981;
    box-shadow: 0 0 5px rgba(16, 185, 129, 0.6);
}

.synced-chip-pending .chip-dot {
    background: #f59e0b;
    box-shadow: 0 0 5px rgba(245, 158, 11, 0.6);
}

.synced-chip-failed .chip-dot {
    background: #ef4444;
    box-shadow: 0 0 5px rgba(239, 68, 68, 0.6);
}

.chip-name {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chip-rows {
    font-size: 0.6rem;
    color: var(--d-text-muted);
    white-space: nowrap;
}

/* Error console */
.error-console {}

.error-console-hdr {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0.55rem 1.25rem;
    font-size: 0.64rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #f87171;
    background: rgba(239, 68, 68, 0.06);
    border-top: 1px solid rgba(239, 68, 68, 0.14);
}

.error-console-body {
    padding: 0.7rem 1.25rem 1rem;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.error-console-body code {
    font-family: 'JetBrains Mono', 'Fira Code', monospace;
    font-size: 0.7rem;
    color: #fca5a5;
    display: block;
    line-height: 1.7;
}

/* ── Engine Logo SVG ────────────────────────────────────────────── */
.eng-logo {
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
}

/* ── Animations ─────────────────────────────────────────────────── */
.spin {
    animation: spinAnim 0.85s linear infinite;
}

@keyframes spinAnim {
    to {
        transform: rotate(360deg);
    }
}

.blink-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 6px #10b981;
    animation: blinkAnim 1.3s ease-in-out infinite;
}

@keyframes blinkAnim {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.25;
    }
}

.anim-slide-down {
    animation: slideDown 0.22s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: none;
    }
}

/* ════════════════════════════════════════════════════════════════
   LIGHT MODE OVERRIDES
   ════════════════════════════════════════════════════════════════ */
html[data-theme="light"] .dboard {
    --d-text-primary: #0f172a;
    --d-text-secondary: #334155;
    --d-text-muted: #64748b;
    --d-card-bg: rgba(255, 255, 255, 0.45);
    --d-card-border: rgba(255, 255, 255, 0.6);
    --d-input-bg: rgba(255, 255, 255, 0.5);
    --d-input-border: rgba(0, 0, 0, 0.08);
    --d-hover-bg: rgba(0, 0, 0, 0.02);
    --d-success-glow: rgba(16, 185, 129, 0.08);
    --d-running-glow: rgba(59, 130, 246, 0.08);
    --d-failed-glow: rgba(239, 68, 68, 0.08);
}

html[data-theme="light"] .dboard-title {
    background: linear-gradient(135deg, #0f172a 40%, #4f46e5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

html[data-theme="light"] .kpi-card {
    background: var(--d-card-bg);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .kpi-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.08);
}

html[data-theme="light"] .d-card {
    background: var(--d-card-bg);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

html[data-theme="light"] .d-card:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.08);
}

html[data-theme="light"] .d-table th {
    background: rgba(255, 255, 255, 0.96);
    border-bottom-color: rgba(0, 0, 0, 0.08);
    color: #000;
}

html[data-theme="light"] .d-table td {
    border-bottom-color: rgba(0, 0, 0, 0.04);
}

html[data-theme="light"] .d-table-row:hover td {
    background: rgba(0, 0, 0, 0.02);
}

html[data-theme="light"] .hbar-track,
html[data-theme="light"] .rel-track,
html[data-theme="light"] .d-prog-track {
    background: rgba(0, 0, 0, 0.06);
}

html[data-theme="light"] .drilldown-card {
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 6px 32px rgba(99, 102, 241, 0.12);
}

html[data-theme="light"] .drilldown-hdr {
    background: rgba(99, 102, 241, 0.03);
}

html[data-theme="light"] .d-filters-panel {
    background: var(--d-card-bg);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
}

html[data-theme="light"] .d-filter-item select,
html[data-theme="light"] .d-filter-search-wrap input {
    background: rgba(255, 255, 255, 0.95);
    color: #0f172a;
}

html[data-theme="light"] .synced-chip {
    background: rgba(255, 255, 255, 0.85);
    color: #334155;
}

html[data-theme="light"] .donut-legend-row:hover,
html[data-theme="light"] .donut-legend-row.active {
    background: rgba(0, 0, 0, 0.03);
}

html[data-theme="light"] .error-console-body {
    background: rgba(239, 68, 68, 0.03);
}

html[data-theme="light"] .error-console-body code {
    color: #b91c1c;
}

html[data-theme="light"] .d-btn {
    background: rgba(0, 0, 0, 0.04);
    color: #475569;
}

html[data-theme="light"] .d-btn:hover {
    background: rgba(99, 102, 241, 0.08);
    color: #1e293b;
}

/* Compact card sizing */
.d-card-compact {
    align-self: stretch;
}



@media (max-width: 580px) {
    .gauge-container-rel {
        flex-direction: column;
        gap: 0.8rem;
    }

    .gauge-left,
    .gauge-right {
        flex: 1 1 100%;
    }
}

html[data-theme="light"] .gauge-mini-chip {
    background: rgba(0, 0, 0, 0.02);
}

/* ── Progress Animated Glow Stripes ── */
.progress-animated-glow {
    position: relative;
    overflow: hidden;
}

.progress-animated-glow::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(-45deg,
            rgba(255, 255, 255, 0.15) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.15) 75%,
            transparent 75%,
            transparent);
    background-size: 30px 30px;
    animation: progress-bar-stripes 1.2s linear infinite;
    opacity: 0.25;
}

@keyframes progress-bar-stripes {
    from {
        background-position: 30px 0;
    }

    to {
        background-position: 0 0;
    }
}

/* ── Total Data Expanded Modal Styling ── */
.total-data-modal-overlay {
    position: fixed;
    top: 70px;
    left: calc(var(--sidebar-width) + 1.25rem);
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.65);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    animation: fadeIn 0.2s ease-out;
    transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.dms-sidebar.collapsed~.dms-main .total-data-modal-overlay {
    left: calc(var(--sidebar-collapsed-width) + 1.25rem);
}

.total-data-modal-content {
    background: var(--d-card-bg);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    width: 100%;
    max-width: 680px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
    animation: scaleIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;
}

.total-data-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.2rem 1.5rem;
    border-bottom: 1px solid var(--d-card-border);
    background: rgba(255, 255, 255, 0.02);
}

.total-data-modal-title-group {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
}

.total-data-modal-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    color: var(--d-text-primary);
}

.total-data-modal-subtitle {
    font-size: 0.72rem;
    color: var(--d-text-muted);
}

.total-data-modal-close {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--d-card-border);
    border-radius: 8px;
    color: var(--d-text-muted);
    font-size: 1.25rem;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.18s;
    line-height: 1;
}

.total-data-modal-close:hover {
    background: rgba(239, 68, 68, 0.15);
    border-color: rgba(239, 68, 68, 0.3);
    color: #f87171;
}

.total-data-modal-body {
    padding: 1.5rem;
    overflow-y: auto;
    flex: 1 1;
}

html[data-theme="light"] .total-data-modal-content {
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* ── Total Data Migrated — Redesigned Widget ───────────────────── */
.tdm-layout {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 1.4rem;
    padding: 0.5rem 0.6rem;
}

.tdm-ring-wrap {
    flex-shrink: 0;
    width: 130px;
    height: 130px;
}

.tdm-stats-panel {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-width: 0;
}

.tdm-main-value {
    font-size: 2rem;
    font-weight: 960;
    color: var(--d-text-primary);
    letter-spacing: -0.04em;
    line-height: 1;
    background: linear-gradient(135deg, #38bdf8, #818cf8);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.tdm-main-label {
    font-size: 0.62rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: var(--d-text-muted);
    margin-top: 5px;
    margin-bottom: 0.8rem;
}

.tdm-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.07);
    margin-bottom: 0.6rem;
}

.tdm-stat-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.32rem 0.65rem;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    margin-bottom: 0.35rem;
    transition: background 0.18s;
}

.tdm-stat-row:hover {
    background: rgba(255, 255, 255, 0.06);
}

.tdm-stat-label {
    font-size: 0.67rem;
    font-weight: 600;
    color: var(--d-text-muted);
}

.tdm-stat-val {
    font-size: 0.82rem;
    font-weight: 800;
    letter-spacing: -0.01em;
}

/* Light theme overrides (existing tdm) */
html[data-theme="light"] .tdm-stat-row {
    background: rgba(0, 0, 0, 0.025);
    border-color: rgba(0, 0, 0, 0.06);
}

html[data-theme="light"] .tdm-stat-row:hover {
    background: rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .tdm-main-value {
    background: linear-gradient(135deg, #0ea5e9, #6366f1);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* ── Total Data Migrated — Centered Hero Layout ────────────────── */
.tdm-center-layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 0.3rem;
    padding: 1rem 1.4rem;
    position: relative;
    overflow: hidden;
    text-align: center;
}

/* Decorative radial glow blob */
.tdm-glow-bg {
    position: absolute;
    top: 38%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 240px;
    height: 130px;
    background: radial-gradient(ellipse at center,
            rgba(56, 189, 248, 0.13) 0%,
            rgba(129, 140, 248, 0.08) 45%,
            transparent 72%);
    pointer-events: none;
    z-index: 0;
}

.tdm-hero-value {
    font-size: 2.8rem;
    font-weight: 960;
    letter-spacing: -0.05em;
    line-height: 1;
    background: linear-gradient(135deg, #38bdf8 0%, #818cf8 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 0 18px rgba(56, 189, 248, 0.25));
}

.tdm-hero-label {
    font-size: 0.6rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--d-text-muted);
    position: relative;
    z-index: 1;
    margin-top: 4px;
    margin-bottom: 1rem;
}

/* Chips container */
.tdm-chips-row {
    display: flex;
    align-items: stretch;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 14px;
    width: 100%;
    max-width: 310px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18),
        inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.tdm-chip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    gap: 4px;
    padding: 0.65rem 0.8rem;
    transition: background 0.18s;
}

.tdm-chip:hover {
    background: rgba(255, 255, 255, 0.05);
}

.tdm-chip-sep {
    width: 1px;
    background: rgba(255, 255, 255, 0.09);
    align-self: stretch;
    flex-shrink: 0;
    margin: 0.55rem 0;
}

.tdm-chip-label {
    font-size: 0.58rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: var(--d-text-muted);
}

.tdm-chip-val {
    font-size: 0.95rem;
    font-weight: 860;
    color: var(--d-text-primary);
    letter-spacing: -0.02em;
}

/* Light theme overrides */
html[data-theme="light"] .tdm-hero-value {
    background: linear-gradient(135deg, #0ea5e9, #6366f1);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 0 12px rgba(14, 165, 233, 0.2));
}

html[data-theme="light"] .tdm-glow-bg {
    background: radial-gradient(ellipse at center,
            rgba(14, 165, 233, 0.1) 0%,
            rgba(99, 102, 241, 0.06) 45%,
            transparent 72%);
}

html[data-theme="light"] .tdm-chips-row {
    background: rgba(0, 0, 0, 0.03);
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

html[data-theme="light"] .tdm-chip-sep {
    background: rgba(0, 0, 0, 0.08);
}

html[data-theme="light"] .tdm-chip:hover {
    background: rgba(0, 0, 0, 0.04);
}

/* ── Telemetry Dedicated Modal Overlay ── */
.telemetry-modal-overlay {
    position: fixed;
    top: 70px;
    left: calc(var(--sidebar-width) + 1.25rem);
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    animation: fadeIn 0.25s ease-out;
    transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.dms-sidebar.collapsed~.dms-main .telemetry-modal-overlay {
    left: calc(var(--sidebar-collapsed-width) + 1.25rem);
}

.telemetry-modal-content {
    background: rgba(15, 23, 42, 0.85);
    /* Deep slate glass */
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    width: 90%;
    max-width: 950px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 24px 64px rgba(0, 0, 0, 0.45);
    animation: scaleIn 250ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
    overflow: hidden;
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
}

.telemetry-modal-body {
    padding: 2.2rem;
    overflow-y: auto;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 1.8rem;
}

.telemetry-modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 1.2rem 2.2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.015);
}

.telemetry-modal-body .drilldown-meta-strip {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.2rem;
    border-bottom: none;
    margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
    .telemetry-modal-body .drilldown-meta-strip {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .telemetry-modal-body .drilldown-meta-strip {
        grid-template-columns: 1fr;
    }
}

.telemetry-modal-body .drilldown-meta-card {
    padding: 1.2rem 1.4rem;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.telemetry-modal-body .drilldown-meta-card:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(168, 85, 247, 0.3);
    transform: translateY(-4px);
    box-shadow: 0 12px 28px -4px rgba(168, 85, 247, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.telemetry-modal-body .drilldown-detail-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
    border-bottom: none;
}

@media (max-width: 768px) {
    .telemetry-modal-body .drilldown-detail-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .telemetry-modal-body .drilldown-detail-grid {
        grid-template-columns: 1fr;
    }
}

.telemetry-modal-body .drilldown-detail-item {
    padding: 1.2rem 1.4rem;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.telemetry-modal-body .drilldown-detail-item:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(168, 85, 247, 0.3);
    transform: translateY(-4px);
    box-shadow: 0 12px 28px -4px rgba(168, 85, 247, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

/* Typography Hierarchy & Contrast */
.telemetry-modal-body .dm-label {
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-muted);
}

.telemetry-modal-body .dm-val {
    font-size: 1.3rem;
    font-weight: 900;
    letter-spacing: -0.02em;
}

.telemetry-modal-body .dd-label {
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--d-text-muted);
}

.telemetry-modal-body .dd-val {
    font-size: 0.88rem;
    font-weight: 700;
    color: var(--d-text-primary);
}

/* Provider Logo Glow */
.telemetry-modal-body .provider-logo-glow {
    filter: drop-shadow(0 0 6px rgba(99, 102, 241, 0.22));
    transition: all 0.3s ease;
}

.telemetry-modal-body .provider-logo-glow:hover {
    filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.55));
    transform: scale(1.1);
}

/* Modernized Status Badges with Soft Glows */
.telemetry-modal-body .d-badge {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.telemetry-modal-body .d-badge-completed {
    box-shadow: 0 0 14px rgba(16, 185, 129, 0.35);
    background: rgba(16, 185, 129, 0.18);
    color: #34d399;
    border: 1px solid rgba(16, 185, 129, 0.35);
}

.telemetry-modal-body .d-badge-running {
    box-shadow: 0 0 14px rgba(59, 130, 246, 0.35);
    background: rgba(59, 130, 246, 0.18);
    color: #60a5fa;
    border: 1px solid rgba(59, 130, 246, 0.35);
}

.telemetry-modal-body .d-badge-failed {
    box-shadow: 0 0 14px rgba(239, 68, 68, 0.35);
    background: rgba(239, 68, 68, 0.18);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.35);
}

.telemetry-modal-body .d-badge-cancelled {
    box-shadow: 0 0 14px rgba(245, 158, 11, 0.35);
    background: rgba(245, 158, 11, 0.18);
    color: #fbbf24;
    border: 1px solid rgba(245, 158, 11, 0.35);
}

.telemetry-modal-body .d-badge-pending {
    box-shadow: 0 0 14px rgba(148, 163, 184, 0.35);
    background: rgba(148, 163, 184, 0.18);
    color: #94a3b8;
    border: 1px solid rgba(148, 163, 184, 0.35);
}

/* Maintain light theme compatibility with Premium Glassmorphism */
html[data-theme="light"] .telemetry-modal-content {
    background: rgba(255, 255, 255, 0.35) !important;
    border: 1px solid rgba(255, 255, 255, 0.45) !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55), 0 24px 64px rgba(0, 0, 0, 0.08) !important;
}

html[data-theme="light"] .telemetry-modal-overlay {
    background: rgba(241, 245, 249, 0.45);
}

html[data-theme="light"] .telemetry-modal-body .drilldown-meta-card,
html[data-theme="light"] .telemetry-modal-body .drilldown-detail-item {
    background: rgba(0, 0, 0, 0.02) !important;
    border-color: rgba(0, 0, 0, 0.06) !important;
}

html[data-theme="light"] .telemetry-modal-body .drilldown-meta-card:hover,
html[data-theme="light"] .telemetry-modal-body .drilldown-detail-item:hover {
    background: rgba(0, 0, 0, 0.04) !important;
    border-color: rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.06) !important;
}


html[data-theme="light"] .telemetry-modal-body .drilldown-meta-card,
html[data-theme="light"] .telemetry-modal-body .drilldown-detail-item {
    background: rgba(0, 0, 0, 0.02) !important;
    border-color: rgba(0, 0, 0, 0.06) !important;
}

html[data-theme="light"] .telemetry-modal-body .drilldown-meta-card:hover,
html[data-theme="light"] .telemetry-modal-body .drilldown-detail-item:hover {
    background: rgba(0, 0, 0, 0.04) !important;
    border-color: rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.06) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/dms/DMSDashboard.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE,qEAAqE;AACrE;IACI,2CAA2C;IAC3C,kDAAkD;IAClD,0CAA0C;IAC1C,kDAAkD;IAClD,8DAA8D;IAC9D,uCAAuC;IACvC,2CAA2C;IAC3C,uCAAuC;IACvC,0CAA0C;IAC1C,0CAA0C;IAC1C,wCAAwC;;IAExC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,+DAA+D;IAC/D,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA,qEAAqE;AACrE,6FAA6F;AAC7F;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA,qEAAqE;AACrE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,uCAAuC;IACvC,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yDAAyD;IACzD,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,qEAAqE;AACrE;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;;IAEI,6BAA6B;IAC7B,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kDAAkD;AACtD;;AAEA;;IAEI,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;;IAEI,sCAAsC;IACtC,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,WAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mDAAmD;IACnD,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sCAAsC;IACtC,aAAa;IACb,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6EAA6E;IAC7E;sCACkC;IAClC,+EAA+E;AACnF;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,4BAA4B;AAChC;;AAEA,aAAa;AACb;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mCAAmC;IACnC,mDAAmD;IACnD,0CAA0C;AAC9C;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,+BAA+B;IAC/B,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,oBAAoB;IACpB,qCAAqC;IACrC,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8CAA8C;AAClD;;AAEA,cAAc;AACd;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mCAAmC;IACnC,0CAA0C;IAC1C,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA,oEAAoE;AACpE;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,mDAAmD;IACnD,4DAA4D;AAChE;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kCAAkC;IAClC,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,oBAAoB;IACpB,yCAAyC;IACzC,2BAA2B;IAC3B,mCAAmC;IACnC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,sEAAsE;AACtE;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,mDAAmD;IACnD,+DAA+D;AACnE;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kCAAkC;IAClC,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,oBAAoB;IACpB,yCAAyC;IACzC,2BAA2B;IAC3B,mCAAmC;IACnC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,uCAAuC;AACvC;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA,qEAAqE;AACrE;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;IACxB,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,kDAAkD;IAClD,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,2CAA2C;AAC/C;;AAEA,sEAAsE;AACtE;IACI,4BAA4B;IAC5B,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,+EAA+E;IAC/E,wDAAwD;IACxD,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;IAC5C,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,uCAAuC;IACvC,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB,gBAAgB;;AAEhB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mCAAmC;IACnC,6CAA6C;AACjD;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA,sEAAsE;AACtE;IACI,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,sEAAsE;AACtE;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;;qEAEqE;AACrE;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,sCAAsC;IACtC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,iCAAiC;IACjC,0CAA0C;IAC1C,0CAA0C;IAC1C,wCAAwC;AAC5C;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;;IAEI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;AACvB;;;;AAIA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;;QAEI,cAAc;IAClB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR;;;;;;;wBAOoB;IACpB,0BAA0B;IAC1B,oDAAoD;IACpD,aAAa;AACjB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,4CAA4C;AAC5C;IACI,eAAe;IACf,SAAS;IACT,0CAA0C;IAC1C,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,+BAA+B;IAC/B,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,4BAA4B;IAC5B,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;IACvB,cAAc;IACd,qDAAqD;IACrD,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,yCAAyC;AACzC;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb;;;4BAGwB;IACxB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,6DAA6D;IAC7D,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,sDAAsD;AAC1D;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB;+CAC2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA,0BAA0B;AAC1B;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,qDAAqD;AACzD;;AAEA;IACI;;;4BAGwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,4CAA4C;AAC5C;IACI,eAAe;IACf,SAAS;IACT,0CAA0C;IAC1C,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,0BAA0B;IAC1B,kCAAkC;IAClC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,2CAA2C;IAC3C,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oFAAoF;IACpF,+DAA+D;IAC/D,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,sBAAsB;IACtB,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,2BAA2B;IAC3B,6FAA6F;AACjG;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,sBAAsB;IACtB,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,2BAA2B;IAC3B,6FAA6F;AACjG;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,uBAAuB;AACvB;IACI,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,sDAAsD;IACtD,qBAAqB;AACzB;;AAEA,6CAA6C;AAC7C;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,4CAA4C;IAC5C,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,cAAc;IACd,2CAA2C;AAC/C;;AAEA,kEAAkE;AAClE;IACI,gDAAgD;IAChD,sDAAsD;IACtD,+FAA+F;AACnG;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;;IAEI,0CAA0C;IAC1C,4CAA4C;IAC5C,2DAA2D;AAC/D;;;AAGA;;IAEI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;;IAEI,0CAA0C;IAC1C,4CAA4C;IAC5C,2DAA2D;AAC/D","sourcesContent":["/* ════════════════════════════════════════════════════════════════\n   DMSDashboard.css — Premium Power BI-style Migration Dashboard\n   Glassmorphism · Frosted transparency · Cloud migration aesthetic\n   Full light/dark theming via CSS variables\n   ════════════════════════════════════════════════════════════════ */\n\n/* ── Design Tokens ─────────────────────────────────────────────── */\n.dboard {\n    --d-text-primary: var(--text-main, #f1f5f9);\n    --d-text-secondary: var(--text-secondary, #94a3b8);\n    --d-text-muted: var(--text-muted, #64748b);\n    --d-card-bg: var(--card-bg, rgba(15, 23, 42, 0.6));\n    --d-card-border: var(--card-border, rgba(255, 255, 255, 0.07));\n    --d-input-bg: rgba(255, 255, 255, 0.04);\n    --d-input-border: rgba(255, 255, 255, 0.08);\n    --d-hover-bg: rgba(255, 255, 255, 0.03);\n    --d-success-glow: rgba(16, 185, 129, 0.15);\n    --d-running-glow: rgba(59, 130, 246, 0.15);\n    --d-failed-glow: rgba(239, 68, 68, 0.15);\n\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif;\n    color: var(--d-text-primary);\n    padding-bottom: 2rem;\n}\n\n/* ── Dashboard Header ──────────────────────────────────────────── */\n/* Dashboard Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */\n.dboard-header-right {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    flex-wrap: wrap;\n}\n\n/* ── Header Buttons & Controls ─────────────────────────────────── */\n.d-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    background: var(--d-input-bg);\n    border: 1px solid var(--d-input-border);\n    border-radius: 8px;\n    color: var(--d-text-secondary);\n    font-family: inherit;\n    font-size: 0.76rem;\n    font-weight: 600;\n    padding: 0.45rem 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    position: relative;\n    white-space: nowrap;\n}\n\n.d-btn:hover {\n    background: rgba(129, 140, 248, 0.1);\n    border-color: rgba(129, 140, 248, 0.4);\n    color: var(--d-text-primary);\n    transform: translateY(-1px);\n}\n\n.d-btn.active {\n    background: rgba(129, 140, 248, 0.15);\n    border-color: rgba(129, 140, 248, 0.5);\n    color: #818cf8;\n    box-shadow: 0 4px 12px rgba(129, 140, 248, 0.15);\n}\n\n.d-btn-icon {\n    padding: 0.45rem 0.65rem;\n}\n\n.d-filter-dot {\n    position: absolute;\n    top: 4px;\n    right: 5px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #818cf8;\n    box-shadow: 0 0 6px #818cf8;\n}\n\n/* Auto-refresh toggle */\n.d-toggle-wrap {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.d-toggle-label {\n    font-size: 0.74rem;\n    font-weight: 700;\n    color: var(--d-text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.toggle-sw {\n    position: relative;\n    display: inline-block;\n    width: 36px;\n    height: 20px;\n}\n\n.toggle-sw input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.toggle-knob {\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.08);\n    border-radius: 20px;\n    cursor: pointer;\n    transition: background 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.toggle-knob::before {\n    content: '';\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    left: 3px;\n    bottom: 3px;\n    background: #fff;\n    border-radius: 50%;\n    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.toggle-sw input:checked+.toggle-knob {\n    background: #818cf8;\n}\n\n.toggle-sw input:checked+.toggle-knob::before {\n    transform: translateX(16px);\n}\n\n/* ── Filters Panel ─────────────────────────────────────────────── */\n.d-filters-panel {\n    background: var(--d-card-bg);\n    border: 1px solid var(--d-card-border);\n    border-radius: 12px;\n    padding: 0.5rem 1rem 0.8rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.7rem;\n    margin-bottom: 0.6rem;\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);\n    position: relative;\n    z-index: 50;\n}\n\n.d-filters-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n    align-items: flex-end;\n}\n\n.d-filter-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    min-width: 140px;\n    flex: 1;\n}\n\n.d-filter-item label {\n    font-size: 0.65rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-muted);\n}\n\n.d-filter-item select,\n.d-filter-search-wrap input {\n    background: var(--d-input-bg);\n    border: 1px solid var(--d-input-border);\n    border-radius: 8px;\n    color: var(--d-text-primary);\n    font-family: inherit;\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 0.4rem 0.75rem;\n    height: 36px;\n    cursor: pointer;\n    outline: none;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.d-filter-item select:hover,\n.d-filter-search-wrap input:hover {\n    border-color: rgba(129, 140, 248, 0.3);\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.d-filter-item select:focus,\n.d-filter-search-wrap input:focus {\n    border-color: rgba(129, 140, 248, 0.6);\n    background: rgba(255, 255, 255, 0.08);\n    box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.15);\n}\n\n.d-filter-search-wrap {\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n    min-width: 200px;\n    flex: 1.5;\n}\n\n.d-search-icon {\n    position: absolute;\n    left: 10px;\n    bottom: 10px;\n    color: var(--d-text-muted);\n    pointer-events: none;\n}\n\n.d-filter-search-wrap input {\n    padding-left: 30px;\n    width: 100%;\n}\n\n.d-reset-btn {\n    background: rgba(239, 68, 68, 0.1);\n    border: 1px solid rgba(239, 68, 68, 0.28);\n    border-radius: 8px;\n    color: #f87171;\n    font-family: inherit;\n    font-size: 0.74rem;\n    font-weight: 700;\n    padding: 0.35rem 0.95rem;\n    cursor: pointer;\n    align-self: flex-end;\n    height: 36px;\n    transition: all 0.2s;\n}\n\n.d-reset-btn:hover {\n    background: rgba(239, 68, 68, 0.18);\n    border-color: rgba(239, 68, 68, 0.45);\n    transform: translateY(-1px);\n}\n\n/* ── KPI Grid ──────────────────────────────────────────────────── */\n.kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 0.8rem;\n}\n\n@media (max-width: 1350px) {\n    .kpi-grid {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (max-width: 920px) {\n    .kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 520px) {\n    .kpi-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.kpi-card {\n    background: var(--d-card-bg);\n    border: 1px solid var(--d-card-border);\n    border-radius: 14px;\n    padding: 1rem 1.1rem;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n}\n\n/* Top accent bar */\n.kpi-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: var(--kpi-accent, #818cf8);\n    opacity: 0.65;\n    border-radius: 14px 14px 0 0;\n    transition: opacity 0.2s;\n}\n\n/* Soft glow bottom-right blob */\n.kpi-card::after {\n    content: '';\n    position: absolute;\n    bottom: -22px;\n    right: -22px;\n    width: 65px;\n    height: 65px;\n    border-radius: 50%;\n    background: var(--kpi-accent, #818cf8);\n    opacity: 0.03;\n    pointer-events: none;\n    transition: opacity 0.25s;\n}\n\n.kpi-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(255, 255, 255, 0.12);\n    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n}\n\n.kpi-card:hover::after {\n    opacity: 0.08;\n}\n\n.kpi-card.kpi-active {\n    border-color: color-mix(in srgb, var(--kpi-accent, #818cf8) 60%, transparent);\n    box-shadow: 0 0 0 1px color-mix(in srgb, var(--kpi-accent, #818cf8) 25%, transparent),\n        0 8px 24px rgba(0, 0, 0, 0.18);\n    background: color-mix(in srgb, var(--kpi-accent, #818cf8) 6%, var(--d-card-bg));\n}\n\n.kpi-card.kpi-active::before {\n    opacity: 1;\n}\n\n.kpi-top-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.kpi-label {\n    font-size: 0.65rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-secondary);\n}\n\n.kpi-icon {\n    color: var(--kpi-accent, #818cf8);\n    opacity: 0.65;\n    display: flex;\n    align-items: center;\n}\n\n.kpi-bottom-row {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 0.35rem;\n}\n\n.kpi-value {\n    font-size: 1.7rem;\n    font-weight: 900;\n    letter-spacing: -0.03em;\n    line-height: 1;\n    color: var(--d-text-primary);\n}\n\n/* KPI hint */\n.kpi-hint-bar {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.72rem;\n    color: var(--d-text-muted);\n    margin-top: -0.35rem;\n}\n\n.kpi-clear-btn {\n    background: rgba(129, 140, 248, 0.1);\n    border: 1px solid rgba(129, 140, 248, 0.28);\n    border-radius: 6px;\n    color: #818cf8;\n    font-family: inherit;\n    font-size: 0.65rem;\n    font-weight: 800;\n    padding: 0.15rem 0.5rem;\n    cursor: pointer;\n    margin-left: 4px;\n    transition: all 0.15s;\n}\n\n.kpi-clear-btn:hover {\n    background: rgba(129, 140, 248, 0.22);\n    color: #a5b4fc;\n}\n\n/* ── Card Layout ───────────────────────────────────────────────── */\n.d-row {\n    display: grid;\n    gap: 0.85rem;\n}\n\n.d-row-2col {\n    grid-template-columns: 1fr 1fr;\n}\n\n.d-row-full {\n    grid-template-columns: 1fr;\n}\n\n@media (max-width: 920px) {\n    .d-row-2col {\n        grid-template-columns: 1fr;\n    }\n}\n\n.d-card {\n    background: var(--d-card-bg);\n    border: 1px solid var(--d-card-border);\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);\n}\n\n.d-card:hover {\n    border-color: rgba(255, 255, 255, 0.11);\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);\n}\n\n.d-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.85rem 1.1rem 0.65rem;\n    border-bottom: 1px solid var(--d-card-border);\n    flex-wrap: wrap;\n}\n\n.d-card-title-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    flex: 1;\n    min-width: 150px;\n}\n\n.d-card-title {\n    margin: 0;\n    font-size: 0.76rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-secondary);\n}\n\n.d-card-sub {\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: var(--d-text-secondary);\n    margin-top: 0.25rem;\n    line-height: 1.4;\n}\n\n.d-card-body {\n    padding: 0.85rem 1.1rem;\n    flex: 1;\n    min-height: 80px;\n    overflow-x: auto;\n}\n\n/* Card Header Toggles (Power BI style) */\n.d-card-tabs {\n    display: inline-flex;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid var(--d-input-border);\n    border-radius: 8px;\n    padding: 2px;\n    gap: 2px;\n}\n\n.d-card-tab {\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    color: var(--d-text-secondary);\n    font-family: inherit;\n    font-size: 0.65rem;\n    font-weight: 700;\n    padding: 0.3rem 0.65rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.d-card-tab:hover {\n    color: var(--d-text-primary);\n}\n\n.d-card-tab.active {\n    background: #818cf8;\n    color: #ffffff;\n    box-shadow: 0 2px 8px rgba(129, 140, 248, 0.4);\n}\n\n/* Live pill */\n.d-live-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 0.64rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #10b981;\n    background: rgba(16, 185, 129, 0.1);\n    border: 1px solid rgba(16, 185, 129, 0.25);\n    border-radius: 20px;\n    padding: 0.16rem 0.6rem;\n}\n\n.d-view-all {\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: #818cf8;\n    text-decoration: none;\n    transition: color 0.15s;\n    flex-shrink: 0;\n}\n\n.d-view-all:hover {\n    color: #a5b4fc;\n}\n\n/* ── Empty State ───────────────────────────────────────────────── */\n.d-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    min-height: 140px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--d-text-muted);\n    text-align: center;\n    padding: 2.5rem 1.5rem;\n}\n\n/* ── Section 1: Donut Chart ────────────────────────────────────── */\n.donut-wrap {\n    display: flex;\n    align-items: center;\n    gap: 2.5rem;\n    padding: 0.4rem 0;\n}\n\n.donut-svg-box {\n    width: 170px;\n    height: 170px;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.donut-seg {\n    transition: stroke-width 0.25s, filter 0.25s;\n}\n\n.donut-seg:hover {\n    stroke-width: 19;\n}\n\n.donut-legend {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.donut-legend-row {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    padding: 0.35rem 0.55rem;\n    border-radius: 8px;\n    transition: background 0.18s;\n}\n\n.donut-legend-row:hover,\n.donut-legend-row.active {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.legend-dot {\n    width: 9px;\n    height: 9px;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n\n.legend-name {\n    font-size: 0.74rem;\n    font-weight: 700;\n    color: var(--d-text-secondary);\n    flex: 1;\n}\n\n.legend-count {\n    font-size: 0.82rem;\n    font-weight: 900;\n    color: var(--d-text-primary);\n}\n\n.legend-pct {\n    font-size: 0.68rem;\n    font-weight: 600;\n    color: var(--d-text-muted);\n    min-width: 42px;\n    text-align: right;\n}\n\n@media (max-width: 480px) {\n    .donut-wrap {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .donut-svg-box {\n        width: 140px;\n        height: 140px;\n    }\n}\n\n/* ── Section 2: Total Data Migrated (Horizontal bars) ─────────── */\n.hbar-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n}\n\n.hbar-row {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.hbar-label-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.6rem;\n}\n\n.hbar-label-left {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    flex: 1;\n    overflow: hidden;\n    min-width: 0;\n}\n\n.hbar-path-name {\n    font-size: 0.74rem;\n    font-weight: 700;\n    color: var(--d-text-secondary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.hbar-val {\n    font-size: 0.78rem;\n    font-weight: 800;\n    flex-shrink: 0;\n}\n\n.hbar-track {\n    height: 8px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.hbar-fill {\n    height: 100%;\n    border-radius: 5px;\n    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.hbar-sub {\n    font-size: 0.62rem;\n    color: var(--d-text-muted);\n    font-weight: 500;\n}\n\n/* ── Section 3: Source→Target Relationship ─────────────────────── */\n.rel-list {\n    display: flex;\n    flex-direction: column;\n    padding: 0.1rem 0;\n}\n\n.rel-row {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    position: relative;\n    padding: 0.5rem 0.75rem;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    animation: slideInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n.rel-row:hover {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.07);\n    transform: translateX(6px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\nhtml[data-theme=\"light\"] .rel-row:hover {\n    background: rgba(0, 0, 0, 0.02);\n    border-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.rel-label-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.rel-path {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    flex: 1;\n    overflow: hidden;\n    min-width: 0;\n}\n\n.rel-src,\n.rel-tgt {\n    font-size: 0.74rem;\n    font-weight: 700;\n    color: var(--d-text-secondary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n}\n\n.rel-arrow {\n    font-size: 0.68rem;\n    color: var(--d-text-muted);\n    flex-shrink: 0;\n}\n\n.rel-meta {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n}\n\n.rel-sr {\n    font-size: 0.65rem;\n    font-weight: 800;\n}\n\n.rel-bar-container {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    width: 100%;\n}\n\n.rel-track {\n    height: 8px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 4px;\n    overflow: hidden;\n    flex: 1;\n}\n\nhtml[data-theme=\"light\"] .rel-track {\n    background: rgba(0, 0, 0, 0.04);\n}\n\n.rel-fill {\n    height: 100%;\n    border-radius: 4px;\n    animation: growBar 1.2s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n.rel-count-end {\n    font-size: 0.72rem;\n    font-weight: 800;\n    color: var(--d-text-secondary);\n    min-width: 22px;\n    text-align: right;\n    flex-shrink: 0;\n}\n\n/* Relationship Tooltip (glassmorphism) */\n.rel-tooltip {\n    position: absolute;\n    visibility: hidden;\n    opacity: 0;\n    background: rgba(15, 23, 42, 0.96);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 8px 12px;\n    color: #f8fafc;\n    font-size: 0.68rem;\n    z-index: 100;\n    bottom: 110%;\n    left: 50%;\n    transform: translateX(-50%);\n    pointer-events: none;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.rel-row:hover .rel-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* ── Section 4: Radial Gauge ────────────────────────────────────── */\n.gauge-container-rel {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    gap: 1.25rem;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.gauge-left {\n    flex: 1 1 45%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 150px;\n}\n\n.gauge-right {\n    flex: 1 1 55%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 0.8rem;\n    width: 100%;\n}\n\n.gauge-center {\n    position: absolute;\n    top: 72%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.gauge-ring-svg {\n    height: 150px;\n    width: auto;\n    display: block;\n}\n\n.gauge-mini-chip {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid var(--d-card-border);\n    border-radius: 8px;\n    padding: 0.5rem 0.8rem;\n    width: 100%;\n    box-sizing: border-box;\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    animation: slideInRight 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n.gauge-mini-chip:hover {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.12);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n}\n\nhtml[data-theme=\"light\"] .gauge-mini-chip {\n    background: rgba(0, 0, 0, 0.015);\n}\n\nhtml[data-theme=\"light\"] .gauge-mini-chip:hover {\n    background: rgba(0, 0, 0, 0.035);\n    border-color: rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.g-chip-label {\n    font-size: 0.72rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    color: var(--d-text-muted);\n    letter-spacing: 0.05em;\n}\n\n.g-chip-value {\n    font-size: 1.15rem;\n    font-weight: 900;\n}\n\n.color-green {\n    color: #10b981 !important;\n}\n\n.color-red {\n    color: #f87171 !important;\n}\n\n/* Gauge Tooltip */\n.gauge-tooltip {\n    position: absolute;\n    visibility: hidden;\n    opacity: 0;\n    background: rgba(15, 23, 42, 0.96);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 8px 12px;\n    color: #f8fafc;\n    font-size: 0.68rem;\n    z-index: 100;\n    bottom: 80%;\n    left: 50%;\n    transform: translateX(-50%);\n    pointer-events: none;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.gauge-container-rel:hover .gauge-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Compact layout overrides for cards */\n.d-card-compact .d-card-header {\n    padding: 0.65rem 1rem 0.45rem;\n}\n\n.d-card-compact .d-card-body {\n    padding: 0.65rem 1rem;\n}\n\n/* Animations */\n@keyframes slideInUp {\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideInRight {\n    from {\n        opacity: 0;\n        transform: translateX(15px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes growBar {\n    from {\n        width: 0%;\n    }\n}\n\n/* ── Section 5 / 6: Data Tables ────────────────────────────────── */\n.d-table-scroll {\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: 320px;\n}\n\n.d-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.74rem;\n}\n\n.d-table th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: var(--d-card-bg);\n    text-align: left;\n    font-size: 0.62rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-primary);\n    padding: 0.65rem 0.95rem;\n    border-bottom: 1px solid var(--d-card-border);\n    white-space: nowrap;\n}\n\n.d-table td {\n    padding: 0.65rem 0.95rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n    color: var(--d-text-secondary);\n    font-weight: 500;\n    vertical-align: middle;\n}\n\n.d-table-row {\n    cursor: pointer;\n}\n\n.d-table-row:hover td {\n    background: var(--d-hover-bg);\n}\n\n.d-table-row:last-child td {\n    border-bottom: none;\n}\n\n.d-name-cell {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 240px;\n    overflow: hidden;\n}\n\n.d-job-name {\n    color: var(--d-text-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 180px;\n}\n\n.d-live-badge {\n    font-size: 0.54rem;\n    font-weight: 900;\n    color: #10b981;\n    background: rgba(16, 185, 129, 0.1);\n    border: 1px solid rgba(16, 185, 129, 0.28);\n    border-radius: 4px;\n    padding: 0.1rem 0.32rem;\n    letter-spacing: 0.05em;\n    flex-shrink: 0;\n}\n\n.d-path-cell {\n    font-size: 0.68rem;\n    color: var(--d-text-muted) !important;\n    white-space: nowrap;\n}\n\n.d-engine-cell {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n}\n\n.d-bytes-cell {\n    color: #38bdf8 !important;\n}\n\n.d-small {\n    font-size: 0.66rem !important;\n    white-space: nowrap;\n}\n\n.d-muted {\n    color: var(--d-text-muted) !important;\n}\n\n/* Progress bar */\n.d-prog-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 100px;\n}\n\n.d-prog-track {\n    flex: 1;\n    height: 6px;\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.d-prog-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #3b82f6, #60a5fa);\n    border-radius: 4px;\n    transition: width 0.5s ease;\n}\n\n.d-prog-num {\n    font-size: 0.66rem;\n    font-weight: 800;\n    color: #60a5fa;\n    white-space: nowrap;\n}\n\n/* Status Badges */\n.d-badge {\n    display: inline-block;\n    padding: 0.2rem 0.6rem;\n    border-radius: 20px;\n    font-size: 0.64rem;\n    font-weight: 800;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n}\n\n.d-badge-running {\n    background: rgba(59, 130, 246, 0.12);\n    color: #60a5fa;\n    border: 1px solid rgba(59, 130, 246, 0.28);\n}\n\n.d-badge-completed {\n    background: rgba(16, 185, 129, 0.12);\n    color: #34d399;\n    border: 1px solid rgba(16, 185, 129, 0.28);\n}\n\n.d-badge-failed {\n    background: rgba(239, 68, 68, 0.12);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.28);\n}\n\n.d-badge-cancelled {\n    background: rgba(245, 158, 11, 0.1);\n    color: #fbbf24;\n    border: 1px solid rgba(245, 158, 11, 0.28);\n}\n\n.d-badge-pending {\n    background: rgba(148, 163, 184, 0.1);\n    color: #94a3b8;\n    border: 1px solid rgba(148, 163, 184, 0.28);\n}\n\n/* ── Drilldown Panel ────────────────────────────────────────────── */\n.drilldown-card {\n    background: var(--d-card-bg);\n    border: 1px solid rgba(129, 140, 248, 0.35);\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.1), 0 12px 42px rgba(0, 0, 0, 0.26);\n    animation: slideDown 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n}\n\n.drilldown-hdr {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.9rem 1.25rem;\n    border-bottom: 1px solid var(--d-card-border);\n    background: rgba(129, 140, 248, 0.04);\n}\n\n.drilldown-title {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    font-size: 0.82rem;\n    font-weight: 700;\n    color: var(--d-text-primary);\n    flex: 1;\n    flex-wrap: wrap;\n}\n\n.drilldown-close {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--d-card-border);\n    border-radius: 8px;\n    color: var(--d-text-muted);\n    font-size: 1.2rem;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.18s;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n.drilldown-close:hover {\n    background: rgba(239, 68, 68, 0.15);\n    border-color: rgba(239, 68, 68, 0.3);\n    color: #f87171;\n}\n\n.drilldown-meta-strip {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    border-bottom: 1px solid var(--d-card-border);\n}\n\n@media (max-width: 700px) {\n    .drilldown-meta-strip {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.drilldown-meta-card {\n    padding: 0.85rem 1.25rem;\n    border-right: 1px solid var(--d-card-border);\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.drilldown-meta-card:last-child {\n    border-right: none;\n}\n\n.dm-label {\n    font-size: 0.62rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-muted);\n}\n\n.dm-val {\n    font-size: 1.15rem;\n    font-weight: 900;\n    letter-spacing: -0.02em;\n}\n\n.dm-cyan {\n    color: #38bdf8;\n}\n\n.dm-red {\n    color: #f87171;\n}\n\n.dm-green {\n    color: #34d399;\n}\n\n.drilldown-detail-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    border-bottom: 1px solid var(--d-card-border);\n}\n\n@media (max-width: 700px) {\n    .drilldown-detail-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.drilldown-detail-item {\n    padding: 0.75rem 1.25rem;\n    border-right: 1px solid var(--d-card-border);\n    border-bottom: 1px solid var(--d-card-border);\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.drilldown-detail-item:nth-child(3n) {\n    border-right: none;\n}\n\n.dd-label {\n    font-size: 0.6rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-muted);\n}\n\n.dd-val {\n    font-size: 0.78rem;\n    font-weight: 700;\n    color: var(--d-text-primary);\n}\n\n/* Synced tables */\n.synced-section {\n    padding: 0.95rem 1.25rem;\n    border-bottom: 1px solid var(--d-card-border);\n}\n\n.synced-hdr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.6rem;\n    margin-bottom: 0.8rem;\n    flex-wrap: wrap;\n}\n\n.synced-hdr>span {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.68rem;\n    font-weight: 800;\n    color: var(--d-text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n\n.synced-search-wrap {\n    position: relative;\n}\n\n.synced-search-icon {\n    position: absolute;\n    left: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--d-text-muted);\n    pointer-events: none;\n}\n\n.synced-search-input {\n    padding-left: 26px;\n    font-size: 0.7rem;\n    height: 28px;\n    border-radius: 6px;\n    background: var(--d-input-bg);\n    border: 1px solid var(--d-input-border);\n    color: var(--d-text-primary);\n    font-family: inherit;\n    outline: none;\n    min-width: 160px;\n}\n\n.synced-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n}\n\n.synced-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid var(--d-card-border);\n    border-radius: 6px;\n    padding: 0.3rem 0.6rem;\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: var(--d-text-secondary);\n    transition: background 0.15s;\n}\n\n.synced-chip:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.chip-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.2);\n    flex-shrink: 0;\n}\n\n.synced-chip-completed .chip-dot {\n    background: #10b981;\n    box-shadow: 0 0 5px rgba(16, 185, 129, 0.6);\n}\n\n.synced-chip-pending .chip-dot {\n    background: #f59e0b;\n    box-shadow: 0 0 5px rgba(245, 158, 11, 0.6);\n}\n\n.synced-chip-failed .chip-dot {\n    background: #ef4444;\n    box-shadow: 0 0 5px rgba(239, 68, 68, 0.6);\n}\n\n.chip-name {\n    max-width: 140px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.chip-rows {\n    font-size: 0.6rem;\n    color: var(--d-text-muted);\n    white-space: nowrap;\n}\n\n/* Error console */\n.error-console {}\n\n.error-console-hdr {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 0.55rem 1.25rem;\n    font-size: 0.64rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #f87171;\n    background: rgba(239, 68, 68, 0.06);\n    border-top: 1px solid rgba(239, 68, 68, 0.14);\n}\n\n.error-console-body {\n    padding: 0.7rem 1.25rem 1rem;\n    background: rgba(0, 0, 0, 0.25);\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.error-console-body code {\n    font-family: 'JetBrains Mono', 'Fira Code', monospace;\n    font-size: 0.7rem;\n    color: #fca5a5;\n    display: block;\n    line-height: 1.7;\n}\n\n/* ── Engine Logo SVG ────────────────────────────────────────────── */\n.eng-logo {\n    flex-shrink: 0;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n/* ── Animations ─────────────────────────────────────────────────── */\n.spin {\n    animation: spinAnim 0.85s linear infinite;\n}\n\n@keyframes spinAnim {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.blink-dot {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #10b981;\n    box-shadow: 0 0 6px #10b981;\n    animation: blinkAnim 1.3s ease-in-out infinite;\n}\n\n@keyframes blinkAnim {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.25;\n    }\n}\n\n.anim-slide-down {\n    animation: slideDown 0.22s ease-out;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: none;\n    }\n}\n\n/* ════════════════════════════════════════════════════════════════\n   LIGHT MODE OVERRIDES\n   ════════════════════════════════════════════════════════════════ */\nhtml[data-theme=\"light\"] .dboard {\n    --d-text-primary: #0f172a;\n    --d-text-secondary: #334155;\n    --d-text-muted: #64748b;\n    --d-card-bg: rgba(255, 255, 255, 0.45);\n    --d-card-border: rgba(255, 255, 255, 0.6);\n    --d-input-bg: rgba(255, 255, 255, 0.5);\n    --d-input-border: rgba(0, 0, 0, 0.08);\n    --d-hover-bg: rgba(0, 0, 0, 0.02);\n    --d-success-glow: rgba(16, 185, 129, 0.08);\n    --d-running-glow: rgba(59, 130, 246, 0.08);\n    --d-failed-glow: rgba(239, 68, 68, 0.08);\n}\n\nhtml[data-theme=\"light\"] .dboard-title {\n    background: linear-gradient(135deg, #0f172a 40%, #4f46e5 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\nhtml[data-theme=\"light\"] .kpi-card {\n    background: var(--d-card-bg);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .kpi-card:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\nhtml[data-theme=\"light\"] .d-card {\n    background: var(--d-card-bg);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\nhtml[data-theme=\"light\"] .d-card:hover {\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\nhtml[data-theme=\"light\"] .d-table th {\n    background: rgba(255, 255, 255, 0.96);\n    border-bottom-color: rgba(0, 0, 0, 0.08);\n    color: #000;\n}\n\nhtml[data-theme=\"light\"] .d-table td {\n    border-bottom-color: rgba(0, 0, 0, 0.04);\n}\n\nhtml[data-theme=\"light\"] .d-table-row:hover td {\n    background: rgba(0, 0, 0, 0.02);\n}\n\nhtml[data-theme=\"light\"] .hbar-track,\nhtml[data-theme=\"light\"] .rel-track,\nhtml[data-theme=\"light\"] .d-prog-track {\n    background: rgba(0, 0, 0, 0.06);\n}\n\nhtml[data-theme=\"light\"] .drilldown-card {\n    background: rgba(255, 255, 255, 0.96);\n    box-shadow: 0 6px 32px rgba(99, 102, 241, 0.12);\n}\n\nhtml[data-theme=\"light\"] .drilldown-hdr {\n    background: rgba(99, 102, 241, 0.03);\n}\n\nhtml[data-theme=\"light\"] .d-filters-panel {\n    background: var(--d-card-bg);\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);\n}\n\nhtml[data-theme=\"light\"] .d-filter-item select,\nhtml[data-theme=\"light\"] .d-filter-search-wrap input {\n    background: rgba(255, 255, 255, 0.95);\n    color: #0f172a;\n}\n\nhtml[data-theme=\"light\"] .synced-chip {\n    background: rgba(255, 255, 255, 0.85);\n    color: #334155;\n}\n\nhtml[data-theme=\"light\"] .donut-legend-row:hover,\nhtml[data-theme=\"light\"] .donut-legend-row.active {\n    background: rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme=\"light\"] .error-console-body {\n    background: rgba(239, 68, 68, 0.03);\n}\n\nhtml[data-theme=\"light\"] .error-console-body code {\n    color: #b91c1c;\n}\n\nhtml[data-theme=\"light\"] .d-btn {\n    background: rgba(0, 0, 0, 0.04);\n    color: #475569;\n}\n\nhtml[data-theme=\"light\"] .d-btn:hover {\n    background: rgba(99, 102, 241, 0.08);\n    color: #1e293b;\n}\n\n/* Compact card sizing */\n.d-card-compact {\n    align-self: stretch;\n}\n\n\n\n@media (max-width: 580px) {\n    .gauge-container-rel {\n        flex-direction: column;\n        gap: 0.8rem;\n    }\n\n    .gauge-left,\n    .gauge-right {\n        flex: 1 1 100%;\n    }\n}\n\nhtml[data-theme=\"light\"] .gauge-mini-chip {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n/* ── Progress Animated Glow Stripes ── */\n.progress-animated-glow {\n    position: relative;\n    overflow: hidden;\n}\n\n.progress-animated-glow::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-image: linear-gradient(-45deg,\n            rgba(255, 255, 255, 0.15) 25%,\n            transparent 25%,\n            transparent 50%,\n            rgba(255, 255, 255, 0.15) 50%,\n            rgba(255, 255, 255, 0.15) 75%,\n            transparent 75%,\n            transparent);\n    background-size: 30px 30px;\n    animation: progress-bar-stripes 1.2s linear infinite;\n    opacity: 0.25;\n}\n\n@keyframes progress-bar-stripes {\n    from {\n        background-position: 30px 0;\n    }\n\n    to {\n        background-position: 0 0;\n    }\n}\n\n/* ── Total Data Expanded Modal Styling ── */\n.total-data-modal-overlay {\n    position: fixed;\n    top: 70px;\n    left: calc(var(--sidebar-width) + 1.25rem);\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.65);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    z-index: 10000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem;\n    animation: fadeIn 0.2s ease-out;\n    transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dms-sidebar.collapsed~.dms-main .total-data-modal-overlay {\n    left: calc(var(--sidebar-collapsed-width) + 1.25rem);\n}\n\n.total-data-modal-content {\n    background: var(--d-card-bg);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n    width: 100%;\n    max-width: 680px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n    animation: scaleIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    overflow: hidden;\n}\n\n.total-data-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.2rem 1.5rem;\n    border-bottom: 1px solid var(--d-card-border);\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.total-data-modal-title-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n}\n\n.total-data-modal-title {\n    margin: 0;\n    font-size: 1.15rem;\n    font-weight: 800;\n    color: var(--d-text-primary);\n}\n\n.total-data-modal-subtitle {\n    font-size: 0.72rem;\n    color: var(--d-text-muted);\n}\n\n.total-data-modal-close {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--d-card-border);\n    border-radius: 8px;\n    color: var(--d-text-muted);\n    font-size: 1.25rem;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.18s;\n    line-height: 1;\n}\n\n.total-data-modal-close:hover {\n    background: rgba(239, 68, 68, 0.15);\n    border-color: rgba(239, 68, 68, 0.3);\n    color: #f87171;\n}\n\n.total-data-modal-body {\n    padding: 1.5rem;\n    overflow-y: auto;\n    flex: 1;\n}\n\nhtml[data-theme=\"light\"] .total-data-modal-content {\n    background: rgba(255, 255, 255, 0.96);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes scaleIn {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* ── Total Data Migrated — Redesigned Widget ───────────────────── */\n.tdm-layout {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    gap: 1.4rem;\n    padding: 0.5rem 0.6rem;\n}\n\n.tdm-ring-wrap {\n    flex-shrink: 0;\n    width: 130px;\n    height: 130px;\n}\n\n.tdm-stats-panel {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n}\n\n.tdm-main-value {\n    font-size: 2rem;\n    font-weight: 960;\n    color: var(--d-text-primary);\n    letter-spacing: -0.04em;\n    line-height: 1;\n    background: linear-gradient(135deg, #38bdf8, #818cf8);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.tdm-main-label {\n    font-size: 0.62rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: var(--d-text-muted);\n    margin-top: 5px;\n    margin-bottom: 0.8rem;\n}\n\n.tdm-divider {\n    height: 1px;\n    background: rgba(255, 255, 255, 0.07);\n    margin-bottom: 0.6rem;\n}\n\n.tdm-stat-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.32rem 0.65rem;\n    border-radius: 7px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    margin-bottom: 0.35rem;\n    transition: background 0.18s;\n}\n\n.tdm-stat-row:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.tdm-stat-label {\n    font-size: 0.67rem;\n    font-weight: 600;\n    color: var(--d-text-muted);\n}\n\n.tdm-stat-val {\n    font-size: 0.82rem;\n    font-weight: 800;\n    letter-spacing: -0.01em;\n}\n\n/* Light theme overrides (existing tdm) */\nhtml[data-theme=\"light\"] .tdm-stat-row {\n    background: rgba(0, 0, 0, 0.025);\n    border-color: rgba(0, 0, 0, 0.06);\n}\n\nhtml[data-theme=\"light\"] .tdm-stat-row:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .tdm-main-value {\n    background: linear-gradient(135deg, #0ea5e9, #6366f1);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n/* ── Total Data Migrated — Centered Hero Layout ────────────────── */\n.tdm-center-layout {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    gap: 0.3rem;\n    padding: 1rem 1.4rem;\n    position: relative;\n    overflow: hidden;\n    text-align: center;\n}\n\n/* Decorative radial glow blob */\n.tdm-glow-bg {\n    position: absolute;\n    top: 38%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 240px;\n    height: 130px;\n    background: radial-gradient(ellipse at center,\n            rgba(56, 189, 248, 0.13) 0%,\n            rgba(129, 140, 248, 0.08) 45%,\n            transparent 72%);\n    pointer-events: none;\n    z-index: 0;\n}\n\n.tdm-hero-value {\n    font-size: 2.8rem;\n    font-weight: 960;\n    letter-spacing: -0.05em;\n    line-height: 1;\n    background: linear-gradient(135deg, #38bdf8 0%, #818cf8 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n    z-index: 1;\n    filter: drop-shadow(0 0 18px rgba(56, 189, 248, 0.25));\n}\n\n.tdm-hero-label {\n    font-size: 0.6rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: var(--d-text-muted);\n    position: relative;\n    z-index: 1;\n    margin-top: 4px;\n    margin-bottom: 1rem;\n}\n\n/* Chips container */\n.tdm-chips-row {\n    display: flex;\n    align-items: stretch;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    border-radius: 14px;\n    width: 100%;\n    max-width: 310px;\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18),\n        inset 0 1px 0 rgba(255, 255, 255, 0.07);\n}\n\n.tdm-chip {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    gap: 4px;\n    padding: 0.65rem 0.8rem;\n    transition: background 0.18s;\n}\n\n.tdm-chip:hover {\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.tdm-chip-sep {\n    width: 1px;\n    background: rgba(255, 255, 255, 0.09);\n    align-self: stretch;\n    flex-shrink: 0;\n    margin: 0.55rem 0;\n}\n\n.tdm-chip-label {\n    font-size: 0.58rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: var(--d-text-muted);\n}\n\n.tdm-chip-val {\n    font-size: 0.95rem;\n    font-weight: 860;\n    color: var(--d-text-primary);\n    letter-spacing: -0.02em;\n}\n\n/* Light theme overrides */\nhtml[data-theme=\"light\"] .tdm-hero-value {\n    background: linear-gradient(135deg, #0ea5e9, #6366f1);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    filter: drop-shadow(0 0 12px rgba(14, 165, 233, 0.2));\n}\n\nhtml[data-theme=\"light\"] .tdm-glow-bg {\n    background: radial-gradient(ellipse at center,\n            rgba(14, 165, 233, 0.1) 0%,\n            rgba(99, 102, 241, 0.06) 45%,\n            transparent 72%);\n}\n\nhtml[data-theme=\"light\"] .tdm-chips-row {\n    background: rgba(0, 0, 0, 0.03);\n    border-color: rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\nhtml[data-theme=\"light\"] .tdm-chip-sep {\n    background: rgba(0, 0, 0, 0.08);\n}\n\nhtml[data-theme=\"light\"] .tdm-chip:hover {\n    background: rgba(0, 0, 0, 0.04);\n}\n\n/* ── Telemetry Dedicated Modal Overlay ── */\n.telemetry-modal-overlay {\n    position: fixed;\n    top: 70px;\n    left: calc(var(--sidebar-width) + 1.25rem);\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.55);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    z-index: 10000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n    animation: fadeIn 0.25s ease-out;\n    transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dms-sidebar.collapsed~.dms-main .telemetry-modal-overlay {\n    left: calc(var(--sidebar-collapsed-width) + 1.25rem);\n}\n\n.telemetry-modal-content {\n    background: rgba(15, 23, 42, 0.85);\n    /* Deep slate glass */\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n    width: 90%;\n    max-width: 950px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 24px 64px rgba(0, 0, 0, 0.45);\n    animation: scaleIn 250ms cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    overflow: hidden;\n    backdrop-filter: blur(25px);\n    -webkit-backdrop-filter: blur(25px);\n}\n\n.telemetry-modal-body {\n    padding: 2.2rem;\n    overflow-y: auto;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1.8rem;\n}\n\n.telemetry-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 1.2rem 2.2rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.015);\n}\n\n.telemetry-modal-body .drilldown-meta-strip {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1.2rem;\n    border-bottom: none;\n    margin-bottom: 0.5rem;\n}\n\n@media (max-width: 768px) {\n    .telemetry-modal-body .drilldown-meta-strip {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .telemetry-modal-body .drilldown-meta-strip {\n        grid-template-columns: 1fr;\n    }\n}\n\n.telemetry-modal-body .drilldown-meta-card {\n    padding: 1.2rem 1.4rem;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.telemetry-modal-body .drilldown-meta-card:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(168, 85, 247, 0.3);\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px -4px rgba(168, 85, 247, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.telemetry-modal-body .drilldown-detail-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.2rem;\n    border-bottom: none;\n}\n\n@media (max-width: 768px) {\n    .telemetry-modal-body .drilldown-detail-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .telemetry-modal-body .drilldown-detail-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.telemetry-modal-body .drilldown-detail-item {\n    padding: 1.2rem 1.4rem;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.telemetry-modal-body .drilldown-detail-item:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(168, 85, 247, 0.3);\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px -4px rgba(168, 85, 247, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n/* Typography Hierarchy & Contrast */\n.telemetry-modal-body .dm-label {\n    font-size: 0.72rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-muted);\n}\n\n.telemetry-modal-body .dm-val {\n    font-size: 1.3rem;\n    font-weight: 900;\n    letter-spacing: -0.02em;\n}\n\n.telemetry-modal-body .dd-label {\n    font-size: 0.7rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--d-text-muted);\n}\n\n.telemetry-modal-body .dd-val {\n    font-size: 0.88rem;\n    font-weight: 700;\n    color: var(--d-text-primary);\n}\n\n/* Provider Logo Glow */\n.telemetry-modal-body .provider-logo-glow {\n    filter: drop-shadow(0 0 6px rgba(99, 102, 241, 0.22));\n    transition: all 0.3s ease;\n}\n\n.telemetry-modal-body .provider-logo-glow:hover {\n    filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.55));\n    transform: scale(1.1);\n}\n\n/* Modernized Status Badges with Soft Glows */\n.telemetry-modal-body .d-badge {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.telemetry-modal-body .d-badge-completed {\n    box-shadow: 0 0 14px rgba(16, 185, 129, 0.35);\n    background: rgba(16, 185, 129, 0.18);\n    color: #34d399;\n    border: 1px solid rgba(16, 185, 129, 0.35);\n}\n\n.telemetry-modal-body .d-badge-running {\n    box-shadow: 0 0 14px rgba(59, 130, 246, 0.35);\n    background: rgba(59, 130, 246, 0.18);\n    color: #60a5fa;\n    border: 1px solid rgba(59, 130, 246, 0.35);\n}\n\n.telemetry-modal-body .d-badge-failed {\n    box-shadow: 0 0 14px rgba(239, 68, 68, 0.35);\n    background: rgba(239, 68, 68, 0.18);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.35);\n}\n\n.telemetry-modal-body .d-badge-cancelled {\n    box-shadow: 0 0 14px rgba(245, 158, 11, 0.35);\n    background: rgba(245, 158, 11, 0.18);\n    color: #fbbf24;\n    border: 1px solid rgba(245, 158, 11, 0.35);\n}\n\n.telemetry-modal-body .d-badge-pending {\n    box-shadow: 0 0 14px rgba(148, 163, 184, 0.35);\n    background: rgba(148, 163, 184, 0.18);\n    color: #94a3b8;\n    border: 1px solid rgba(148, 163, 184, 0.35);\n}\n\n/* Maintain light theme compatibility with Premium Glassmorphism */\nhtml[data-theme=\"light\"] .telemetry-modal-content {\n    background: rgba(255, 255, 255, 0.35) !important;\n    border: 1px solid rgba(255, 255, 255, 0.45) !important;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55), 0 24px 64px rgba(0, 0, 0, 0.08) !important;\n}\n\nhtml[data-theme=\"light\"] .telemetry-modal-overlay {\n    background: rgba(241, 245, 249, 0.45);\n}\n\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-meta-card,\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-detail-item {\n    background: rgba(0, 0, 0, 0.02) !important;\n    border-color: rgba(0, 0, 0, 0.06) !important;\n}\n\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-meta-card:hover,\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-detail-item:hover {\n    background: rgba(0, 0, 0, 0.04) !important;\n    border-color: rgba(0, 0, 0, 0.12) !important;\n    box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.06) !important;\n}\n\n\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-meta-card,\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-detail-item {\n    background: rgba(0, 0, 0, 0.02) !important;\n    border-color: rgba(0, 0, 0, 0.06) !important;\n}\n\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-meta-card:hover,\nhtml[data-theme=\"light\"] .telemetry-modal-body .drilldown-detail-item:hover {\n    background: rgba(0, 0, 0, 0.04) !important;\n    border-color: rgba(0, 0, 0, 0.12) !important;\n    box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.06) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
